import Keycloak from 'keycloak-js';

const keycloakConfig = {
  url: 'https://secure.undash-cop.com',
  realm: 'yrb',
  clientId: 'app',
  enableCors: true,
  checkLoginIframe: false,
  checkLoginIframeInterval: 0
};

const keycloak = new Keycloak(keycloakConfig);

export default keycloak;
